/* "Complete the set" on the product page.
   Follows the theme's own variant picker: reads the hidden id input in the product form,
   locks the matching pieces to that colour, and adds everything in one /cart/add.js call. */
(function () {
  function idxBy(names, re) { for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i; return -1; }
  function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return []; } }

  function init(root) {
    var COLOR = /colo/i, SIZE = /size/i;

    var current = parse(root.querySelector('[data-setadd-current]'));
    var currentNames = [];
    try { currentNames = JSON.parse(root.querySelector('[data-setadd-current-names]').dataset.setaddCurrentNames); } catch (e) {}
    var currentColorIdx = idxBy(currentNames, COLOR);

    var pieces = Array.prototype.map.call(root.querySelectorAll('[data-setadd-piece]'), function (el) {
      var names = [];
      try { names = JSON.parse(el.dataset.optionNames || '[]'); } catch (e) {}
      var thumb = el.querySelector('.setadd__shot');
      return {
        el: el, names: names,
        ci: idxBy(names, COLOR), si: idxBy(names, SIZE),
        variants: parse(el.querySelector('[data-setadd-variants]')),
        select: el.querySelector('[data-setadd-size]'),
        toggle: el.querySelector('[data-setadd-toggle]'),
        price: el.querySelector('[data-setadd-price]'),
        status: el.querySelector('[data-setadd-status]'),
        thumb: thumb && thumb.tagName === 'IMG' ? thumb : null,
        thumbDefault: thumb && thumb.tagName === 'IMG' ? thumb.getAttribute('src') : null,
        variant: null, selected: false
      };
    });

    var addBtn = root.querySelector('[data-setadd-add]');
    var addLabel = root.querySelector('[data-setadd-addlabel]');
    var addTotal = root.querySelector('[data-setadd-addtotal]');
    var countEl = root.querySelector('[data-setadd-count]');
    var totalEl = root.querySelector('[data-setadd-total]');
    var errEl = root.querySelector('[data-setadd-error]');
    var fmt = root.dataset.moneyFormat || '${{amount}}';

    var form = document.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('[name="id"]') : null;

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
    }

    function currentVariant() {
      var id = idInput ? parseInt(idInput.value, 10) : null;
      for (var i = 0; i < current.length; i++) if (current[i].id === id) return current[i];
      return current[0] || null;
    }

    function resolve() {
      var cur = currentVariant();
      var color = cur && currentColorIdx >= 0 ? cur.options[currentColorIdx] : null;

      pieces.forEach(function (p) {
        var pool = p.variants.filter(function (v) { return p.ci < 0 || !color || v.options[p.ci] === color; });

        if (p.select) {
          var wanted = p.select.value, ok = false;
          Array.prototype.forEach.call(p.select.options, function (o) {
            if (!o.value) return;
            var can = pool.some(function (v) { return v.options[p.si] === o.value && v.available; });
            o.disabled = !can;
            if (can && o.value === wanted) ok = true;
          });
          if (wanted && !ok) p.select.value = '';
          p.select.disabled = pool.length === 0;
        }

        var size = p.select ? p.select.value : '';
        p.variant = null;
        if (pool.length) {
          if (p.si < 0) p.variant = pool[0].available ? pool[0] : null;
          else if (size) {
            for (var i = 0; i < pool.length; i++) {
              if (pool[i].options[p.si] === size) { p.variant = pool[i].available ? pool[i] : null; break; }
            }
          }
        }

        var none = pool.length === 0;
        p.el.dataset.disabled = none ? 'true' : 'false';
        p.toggle.disabled = none;
        if (none || !p.variant) {
          p.selected = false;
          p.el.dataset.selected = 'false';
          p.toggle.textContent = '+';
          p.toggle.setAttribute('aria-pressed', 'false');
        }

        p.status.textContent = none ? 'Not available in ' + color
          : p.variant ? (color ? color + ' · in stock' : 'In stock')
          : size ? 'Sold out in ' + size
          : color ? color + ' · select a size' : 'Select a size';

        var src = p.variant || pool[0] || p.variants[0];
        if (src) p.price.textContent = src.priceFormatted;

        if (p.thumb) {
          var shot = null;
          for (var n = 0; n < pool.length; n++) { if (pool[n].image) { shot = pool[n].image; break; } }
          if (!shot) shot = p.thumbDefault;
          if (shot && p.thumb.getAttribute('src') !== shot) {
            p.thumb.removeAttribute('srcset');
            p.thumb.setAttribute('src', shot);
          }
        }
      });

      sum();
    }

    function sum() {
      var cur = currentVariant();
      var chosen = pieces.filter(function (p) { return p.selected && p.variant; });
      var cents = (cur ? cur.price : 0) + chosen.reduce(function (t, p) { return t + p.variant.price; }, 0);
      var n = chosen.length + 1;
      countEl.textContent = n === 1
        ? '1 piece · this item'
        : n + ' pieces · full ' + (root.dataset.code || '') + ' set';
      totalEl.textContent = money(cents);
      addTotal.textContent = money(cents);
      addLabel.textContent = chosen.length ? 'Add set to bag' : 'Add to bag';
    }

    pieces.forEach(function (p) {
      if (p.select) p.select.addEventListener('change', function () {
        resolve();
        if (p.variant && !p.selected) p.toggle.click();
      });
      p.toggle.addEventListener('click', function () {
        if (!p.variant) {
          if (p.select && !p.select.value) { p.status.textContent = 'Select a size first'; p.select.focus(); }
          return;
        }
        p.selected = !p.selected;
        p.el.dataset.selected = p.selected ? 'true' : 'false';
        p.toggle.textContent = p.selected ? '\u2713' : '+';
        p.toggle.setAttribute('aria-pressed', String(p.selected));
        sum();
      });
    });

    addBtn.addEventListener('click', function () {
      var cur = currentVariant();
      if (!cur) return;
      var items = [{ id: cur.id, quantity: 1 }];
      pieces.forEach(function (p) { if (p.selected && p.variant) items.push({ id: p.variant.id, quantity: 1 }); });

      errEl.hidden = true;
      var label = addLabel.textContent;
      addBtn.disabled = true;
      addLabel.textContent = 'Adding…';

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('bys:added', { detail: data }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            drawer.open();
            addBtn.disabled = false;
            addLabel.textContent = label;
          } else {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          }
        })
        .catch(function (e) {
          errEl.hidden = false;
          errEl.textContent = (e && e.description) || 'Something went wrong. Please try again.';
          addBtn.disabled = false;
          addLabel.textContent = label;
        });
    });

    var moreBtn = root.querySelector('[data-setadd-more]');
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var hiddenRows = root.querySelectorAll('[data-extra="true"]');
      var opening = moreBtn.getAttribute('aria-expanded') !== 'true';
      Array.prototype.forEach.call(hiddenRows, function (r) { r.hidden = !opening; });
      moreBtn.setAttribute('aria-expanded', String(opening));
      moreBtn.textContent = opening ? 'Show fewer −' : hiddenRows.length + ' more ' +
        (hiddenRows.length === 1 ? 'piece' : 'pieces') + ' in this set +';
    });

    // follow the theme's variant picker, whatever it uses
    if (idInput) {
      var last = idInput.value;
      new MutationObserver(function () {
        if (idInput.value !== last) { last = idInput.value; resolve(); }
      }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      idInput.addEventListener('change', resolve);
      if (form) form.addEventListener('change', function () {
        setTimeout(function () { if (idInput.value !== last) { last = idInput.value; resolve(); } }, 60);
      });
      setInterval(function () {
        if (idInput.value !== last) { last = idInput.value; resolve(); }
      }, 400);
    }

    resolve();
  }

  document.querySelectorAll('[data-setadd]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-setadd]').forEach(init);
  });
})();
